import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'TableEvidence',
  setup: function setup(__props) {
    var selectedEvidence = ref([]);
    return {
      __sfc: true,
      selectedEvidence: selectedEvidence
    };
  }
});